import React from "react";
import { useForm, useWatch } from "react-hook-form";
import { useWorkflowsBuilderPageView } from "../../pages/WorkflowsBuilderPage/WorkflowsBuilderPage.context";
import { useDrawerInvokers } from "@tiny/lib";
import { useGetCustomerTagsQuery } from "../../app/useGeneratedApi";

interface FormValues {
  tags: string[];
}

const useAssignToTagForm = ({ id }: { id: string }) => {
  const { updateNode, getNode, viewMode } = useWorkflowsBuilderPageView();
  const { hideDrawer } = useDrawerInvokers();
  const node = getNode(id);

  const { data: tagsData, isLoading: isLoadingTags } =
    useGetCustomerTagsQuery();

  const methods = useForm<FormValues>({
    defaultValues: {
      tags: node?.data?.tags || [],
    },
    mode: "onChange",
  });

  const { control, handleSubmit, setValue } = methods;
  const formValues = useWatch({ control });

  const [saveDisabled, setSaveDisabled] = React.useState(true);

  React.useEffect(() => {
    const nodeTags = node?.data?.tags || [];
    const formTags = formValues.tags || [];

    const hasChanged =
      nodeTags.length !== formTags.length ||
      formTags.some((tag) => !nodeTags.includes(tag));

    const isValid = formTags.length > 0;

    setSaveDisabled(!hasChanged || !isValid);
  }, [node?.data?.tags, formValues.tags]);

  const onSubmit = handleSubmit((data) => {
    updateNode({
      id,
      data: {
        ...node?.data,
        tags: data.tags,
        tagNames: data.tags.join(", "),
        config: {
          configured: true,
        },
      },
    });
    hideDrawer();
  });

  const handleCancel = () => {
    hideDrawer();
  };

  return {
    methods,
    control,
    formValues,
    onSubmit,
    handleCancel,
    saveDisabled,
    viewMode,
    tags: tagsData?.tags || [],
    isLoadingTags,
  };
};

export default useAssignToTagForm;
